export type KPIComparison =
  | { kind: 'missingPreviousData' }
  | { kind: 'previousValueZero' }
  | { kind: 'noDifference' }
  | { kind: 'delta'; percentage: number };

type NonDeltaKPIComparison = Exclude<KPIComparison, { kind: 'delta' }>;

const KPI_COMPARISON_TOOLTIP_MESSAGES: Record<NonDeltaKPIComparison['kind'], string> =
  {
    missingPreviousData: 'Not enough data for comparison',
    previousValueZero: 'No previous value (it was 0)',
    noDifference: 'No difference with the previous value',
  };

export function getKPIComparison(
  current: number,
  previous: number | null,
): KPIComparison {
  if (previous === null) {
    return { kind: 'missingPreviousData' };
  }

  if (previous === 0) {
    return { kind: 'previousValueZero' };
  }

  const percentage = ((current - previous) / previous) * 100;

  if (percentage === 0) {
    return { kind: 'noDifference' };
  }

  return { kind: 'delta', percentage };
}

export function getKPIComparisonTooltipMessage(
  comparison: NonDeltaKPIComparison,
): string {
  return KPI_COMPARISON_TOOLTIP_MESSAGES[comparison.kind];
}
